import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { OBJECT_getInstance26229tfe4t547 as OBJECT_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  Companion_instance17v8p6g2424o4 as Companion_instance,
  Companion_instancegwok6qx7et5m as Companion_instance_0,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ObjectRenderer$view$lambda($this$ViewRenderer, _unused_var__etf5q3, _unused_var__etf5q3_0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function ObjectRenderer$form$lambda($this$FormRenderer, _unused_var__etf5q3, _unused_var__etf5q3_0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.stack' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  $this$FormRenderer.fbb(p, view);
  return view;
}
var ObjectRendererClass;
function ObjectRenderer() {
  if (ObjectRendererClass === VOID) {
    class $ {
      constructor() {
        ObjectRenderer_instance = this;
        this.he0_1 = OBJECT_getInstance();
        this.ie0_1 = 'Object';
      }
      s11() {
        return this.he0_1;
      }
      k20() {
        return this.ie0_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance;
        return tmp.odu(module_0, this, selector, VOID, VOID, ObjectRenderer$view$lambda);
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_0;
        return tmp.mdu(module_0, this, selector, VOID, VOID, ObjectRenderer$form$lambda);
      }
    }
    protoOf($).f94 = get_type;
    protoOf($).pdu = get_nullable;
    protoOf($).qdu = get_annotation;
    protoOf($).uds = get_handlesField;
    protoOf($).idu = size;
    protoOf($).cdu = get_basePriority;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForObject($, 'ObjectRenderer', VOID, VOID, [Generator(), Generator_0()]);
    ObjectRendererClass = $;
  }
  return ObjectRendererClass;
}
var ObjectRenderer_instance;
function ObjectRenderer_getInstance() {
  if (ObjectRenderer_instance === VOID)
    new (ObjectRenderer())();
  return ObjectRenderer_instance;
}
//region block: exports
export {
  ObjectRenderer_getInstance as ObjectRenderer_getInstance1bejzlvzrz2au,
};
//endregion

//# sourceMappingURL=ObjectRenderer.mjs.map
